// extracted by mini-css-extract-plugin
export default {"root":"qLhPO_","main":"nrDDvr","createPostButton":"ze1XxU"};